export default __webpack_public_path__ + "static/media/33.332639bc.jpeg";